<div
	class="row"
	*ngIf="loading">
	<div class="icon-loading">
		<span>
			<i class="fa fa-circle-notch fa-spin fa-2x"></i>
		</span>

	</div>
</div>

<div
	class="row"
	*ngIf="!loading && !templates?.length">
	<div class="col text-center p-5">
		{{'labels.no-doctemplates' | translate}}
	</div>
</div>

<table
	*ngIf="!loading"
	class="table table-striped thead-dark table-hover table-sm">

	<tbody>
		<tr *ngFor="let row of templates">
			<td>{{row.name}}</td>
			<td>
				<ng-container *ngIf="exporting === row.id; else elseTemplate">{{'labels.generating' | translate}}</ng-container>
				<ng-template #elseTemplate>
					<a
						*ngIf="row.file"
						class="link"
						(click)="generate(row)">
						Genera modulo
					</a>
				</ng-template>
			</td>
		</tr>
	</tbody>
</table>
